import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = {
  style: {"max-height":"500px","height":"500px","overflow-y":"auto"},
  class: "mt-3"
}
const _hoisted_10 = { class: "mt-3 mb-1" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { style: {"max-height":"500px","height":"500px","overflow-y":"auto"} }
const _hoisted_15 = ["title"]
const _hoisted_16 = ["onClick"]

import { ref, computed, watch } from 'vue'

    import { KendoGrid, KendoGridField } from '@Kendo/Components/KendoGrid'
    import { ellipsis, isNullOrWhitespace, strCompareLowerCase } from '@common/Common'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'KendoGridColumnsEditorDialog',
  props: {
    propOpened: { type: Boolean },
    propGrid: {}
  },
  emits: ["close-dialog"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- local state ----------------

    // visible columns model
    const Fields = ref<FieldVM[]>([])
    const Sections = ref<SectionVM[]>([])
    const SearchPhrase = ref<string | null>(null)

    // ---------------- computed ----------------

    const opened = computed(() => props.propOpened)
    const grid = computed(() => props.propGrid ?? null)

    const SelectedFields = computed<FieldVM[]>(() =>
        Fields.value.filter(f => f.IsSelected)
    )

    // ---------------- watcher (opened) ----------------

    watch(opened, (val) =>
    {
        if (val !== true || !grid.value) return

        const columns = grid.value.GetOptions().GetColumns()
            .filter(c => !isNullOrWhitespace(c.title))
            .filter(c => c.command == null)
            .filter(c => c.hidden !== true)
            .map(c => c.field)

        Fields.value = grid.value.GetFields()
            .filter(f => f.HasColumn)
            .map(f => new FieldVM(f))

        Fields.value
            .filter(f => columns.includes(f.Id))
            .forEach(f => { f.IsSelected = true })

        Sections.value = Fields.value
            .map(f => f.Section)
            .filter((v, i, arr) => arr.indexOf(v) === i)
            .sort((a, b) => strCompareLowerCase(a, b))
            .map(name => new SectionVM(name))
    })

    // ---------------- actions ----------------

    function ToggleColumnCommand(fieldId: string)
    {
        const fieldVM = Fields.value.find(f => f.Id === fieldId)
        if (fieldVM) fieldVM.IsSelected = !fieldVM.IsSelected
    }

    function AddColumnCommand(fieldId: string)
    {
        const fieldVM = Fields.value.find(f => f.Id === fieldId)
        if (fieldVM) fieldVM.IsSelected = true
    }

    function RemoveColumnCommand(fieldId: string)
    {
        const fieldVM = Fields.value.find(f => f.Id === fieldId)
        if (fieldVM) fieldVM.IsSelected = false
    }

    function confirm()
    {
        if (!grid.value) return
        grid.value.SetColumns(SelectedFields.value.map(f => f.Id))
        close()
    }

    function close()
    {
        emit('close-dialog')
    }

    // ---------------- helper classes ----------------

    class SectionVM
    {
        Name: string

        constructor(name: string)
        {
            this.Name = name
        }

        get Fields(): FieldVM[]
        {
            let fields = Fields.value.filter(f => f.Section === this.Name)

            if (!isNullOrWhitespace(SearchPhrase.value))
            {
                const phrase = SearchPhrase.value!.toLowerCase()
                fields = fields.filter(f => f.Title.toLowerCase().includes(phrase))
            }

            return fields.sort((a, b) => strCompareLowerCase(a.Title, b.Title))
        }
    }

    class FieldVM
    {
        Id: string
        Title: string
        Section: string
        IsSelected = false
        TitleEllipsis: string

        constructor(field: KendoGridField)
        {
            this.Id = field.FieldId
            this.Title = field.ColumnTitle
            this.Section = field.Section
            this.TitleEllipsis = ellipsis(this.Title, 52)
        }
    }

return (_ctx: any,_cache: any) => {
  return (opened.value === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "modal-title" }, "Choose which columns you see", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("input", {
                        type: "search",
                        placeholder: "Search...",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((SearchPhrase).value = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, SearchPhrase.value]
                      ]),
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "input-group-append" }, [
                        _createElementVNode("span", { class: "input-group-text" }, [
                          _createElementVNode("i", {
                            class: "fa-solid fa-magnifying-glass",
                            "aria-hidden": "true"
                          })
                        ])
                      ], -1 /* CACHED */))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Sections.value, (s) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: s.Name
                        }, [
                          _createElementVNode("h6", _hoisted_10, _toDisplayString(s.Name), 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.Fields, (f) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: f.Id
                            }, [
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (ToggleColumnCommand(f.Id))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["fa-regular fa-lg mr-1", f.IsSelected ? 'fa-square-check' : 'fa-square'])
                                }, null, 2 /* CLASS */),
                                _createElementVNode("span", {
                                  title: f.Title
                                }, _toDisplayString(f.TitleEllipsis), 9 /* TEXT, PROPS */, _hoisted_12)
                              ], 8 /* PROPS */, _hoisted_11)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h5", null, "Selected columns (" + _toDisplayString(SelectedFields.value.length) + "):", 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(SelectedFields.value, (f) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: f.Id,
                          class: "p-2 bg-secondary m-2 text-white"
                        }, [
                          _createElementVNode("span", {
                            title: f.Title
                          }, _toDisplayString(f.TitleEllipsis), 9 /* TEXT, PROPS */, _hoisted_15),
                          _createElementVNode("button", {
                            type: "button",
                            class: "p-0 border-0 text-white",
                            style: {"background-color":"transparent","font-size":"1.3rem","float":"right"},
                            onClick: ($event: any) => (RemoveColumnCommand(f.Id))
                          }, " × ", 8 /* PROPS */, _hoisted_16)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Close"),
                _createElementVNode("button", {
                  type: "button",
                  onClick: confirm,
                  class: "btn btn-primary"
                }, "Confirm")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})